import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "select-sh-topics" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_el_select_v2 = _resolveComponent("el-select-v2")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loader, {
            inline: "",
            tiny: ""
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "Auto Follow Topics", -1 /* HOISTED */)),
          _createVNode(_component_el_select_v2, {
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
            placeholder: "Auto Follow Topics",
            multiple: "",
            filterable: "",
            clearable: "",
            remote: "",
            "multiple-limit": 30,
            "remote-method": $options.searchShTopics,
            loading: $data.options == undefined,
            options: $data.options || []
          }, null, 8 /* PROPS */, ["modelValue", "remote-method", "loading", "options"])
        ]))
  ]))
}